import React from 'react'
import { useTheme } from '../../../components/hooks/useTheme';
import { Divider, FormControlLabel, Radio, RadioGroup } from '@mui/material';

type SecurityDepositSettingsProps = {
    securityDepositId: number;
    setSecurityDepositId: (value: number) => void;
    wasSecurityDepositManuallyChanged: boolean;
    setWasSecurityDepositManuallyChanged: (value: boolean) => void;
    wasExcessChargedFromSecurityDeposit: boolean;
    setWasExcessChargedFromSecurityDeposit: (value: boolean) => void;
    securityDepositPaid: boolean;
    setSecurityDepositPaid: (value: boolean) => void;
    securityDepositRefunded: boolean;
    setSecurityDepositRefunded: (value: boolean) => void;
}

const SecurityDepositSettings = ({
    securityDepositId,
    setSecurityDepositId,
    wasSecurityDepositManuallyChanged,
    setWasSecurityDepositManuallyChanged,
    wasExcessChargedFromSecurityDeposit,
    setWasExcessChargedFromSecurityDeposit,
    securityDepositPaid,
    setSecurityDepositPaid,
    securityDepositRefunded,
    setSecurityDepositRefunded

}: SecurityDepositSettingsProps) => {
    const { themeStyles } = useTheme();

    return (
        <div className="mt-[1.5rem]">
            <span className={`text-[14px] font-semibold inline-block mb-2 ${themeStyles.main.textHeadingColor}`}>
                Security Deposits
            </span>

            <Divider className={`w-full ${themeStyles.divider.bg}`} />

            <div className="grid grid-cols-2 gap-x-6 gap-y-2 mt-[1rem]">
                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Forced Security Deposit</label>
                    <select
                        className={`w-full px-[8px] py-[8px] border rounded-md ${themeStyles.form.tailwindBorderColor} outline-none focus:border-[#167AC3] text-sm ${themeStyles.form.tailwindInputTextColor} bg-transparent`}
                        value={securityDepositId}
                        onChange={(e) => setSecurityDepositId(parseInt(e.target.value))}
                    >
                        <option value={0}></option>
                    </select>
                </div>

                <div />

                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Security Deposit was Manually Changed?</label>
                    <RadioGroup
                        row
                        value={wasSecurityDepositManuallyChanged ? "Yes" : "No"}
                        onChange={(e) => setWasSecurityDepositManuallyChanged(e.target.value === "Yes")}
                    >
                        <FormControlLabel
                            value="Yes"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="Yes"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />

                        <FormControlLabel
                            value="No"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="No"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />
                    </RadioGroup>
                </div>

                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Security Deposit Excess was Manually Changed?</label>
                    <RadioGroup
                        row
                        value={wasExcessChargedFromSecurityDeposit ? "Yes" : "No"}
                        onChange={(e) => setWasExcessChargedFromSecurityDeposit(e.target.value === "Yes")}
                    >
                        <FormControlLabel
                            value="Yes"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="Yes"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />

                        <FormControlLabel
                            value="No"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="No"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />
                    </RadioGroup>
                </div>

                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Security Deposit Paid?</label>
                    <RadioGroup
                        row
                        value={securityDepositPaid ? "Yes" : "No"}
                        onChange={(e) => setSecurityDepositPaid(e.target.value === "Yes")}
                    >
                        <FormControlLabel
                            value="Yes"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="Yes"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />

                        <FormControlLabel
                            value="No"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="No"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />
                    </RadioGroup>
                </div>

                <div>
                    <label className={`text-xs font-medium ${themeStyles.form.tailwindLabelTextColor}`}>Security Deposit Refunded?</label>
                    <RadioGroup
                        row
                        value={securityDepositRefunded ? "Yes" : "No"}
                        onChange={(e) => setSecurityDepositRefunded(e.target.value === "Yes")}
                    >
                        <FormControlLabel
                            value="Yes"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="Yes"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />

                        <FormControlLabel
                            value="No"
                            control={
                                <Radio
                                    sx={{
                                        color: "gray",
                                        "&.Mui-checked": {
                                            color: "#167AC3",
                                        },
                                        '& .MuiSvgIcon-root': {
                                            fontSize: 14,
                                        },
                                    }}
                                />
                            }
                            label="No"
                            sx={{
                                color: themeStyles.form.labelTextColor
                            }}
                        />
                    </RadioGroup>
                </div>
            </div>
        </div>
    )
}

export default SecurityDepositSettings